/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import {IndexedObject} from '@dvrd/dvr-controls';

export interface SystemOptions extends IndexedObject<any> {
    platformUrl: string;
    sentryUrl: string | null;
    appBaseUrl: string;
    gaID: string | null;
    mode: 'prod' | 'test' | 'dev';
}

interface Settings extends IndexedObject<SystemOptions> {
    prod: SystemOptions;
    dev: SystemOptions;
    accept: SystemOptions;
}

const defaultSettings: SystemOptions = {
    mode: 'prod',
    platformUrl: '',
    sentryUrl: null,
    appBaseUrl: '',
    gaID: null,
};

const appSettings: Settings = {
    prod: {
        ...defaultSettings,
        platformUrl: 'https://yt.davevanrijn.nl/yt-core/v1/',
        gaID: '',
    },
    accept: {
        ...defaultSettings,
        mode: 'test',
        platformUrl: '',
    },
    dev: {
        ...defaultSettings,
        mode: 'dev',
        platformUrl: 'http://127.0.0.1:30377/v1/',
    }
};

const mode = window.mode || 'prod';
window.settings = appSettings[mode];
